﻿import {translation} from "@2d-front-monorepo/core";
import {showErrorDialog, toggleLoadingDialog} from "@2d-front-monorepo/design-library";
import {formatCurrency, ReservationResult, Reservations} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {NavigateFunction} from "react-router";
import {PrivateRoutes} from "../routes";
import {getHttpClient} from "./getHttpClient";
import {ReloadEntities, reloadPermits} from "./reloadPermits";

export async function cancelReservation(reservation: ReservationResult, navigate: NavigateFunction): Promise<void> {
	const isActive = Reservations.isActive(reservation);
	let message: string;
	const args = {
		total: formatCurrency(reservation.payment?.quotation?.price.totalWithVat)
	};

	if (isActive) {
		message = translation([
			{text: `summary-page__cancel-active-reservation__${reservation.tariffId}--alert`, args},
			{text: PermitTranslations.summary_page__cancel_active_reservation__alert, args}
		]);
	} else {
		message = translation([
			{text: `summary-page__cancel-reservation__${reservation.tariffId}--alert`, args},
			{text: PermitTranslations.summary_page__cancel_reservation__alert, args}
		]);
	}

	if (!confirm(message)) {
		return;
	}

	const httpClient = getHttpClient();

	try {
		toggleLoadingDialog(true);
		await httpClient.reservations.cancel(reservation.id);
		await reloadPermits(ReloadEntities.Reservations)
		navigate(PrivateRoutes.permitsList);
	} catch (error) {
		showErrorDialog(error);
	} finally {
		toggleLoadingDialog(false);
	}
}
